import React from 'react'
import { useNavigate } from 'react-router'

import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_SIZE_SMALL, BASIC_BUTTON_TYPE_FLAT } from '@divvy-web/skylab.basicbutton'

import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

interface ViewDetailsButtonProps {
  salesforceCreditId: string
}

const ViewDetailsButton = ({ salesforceCreditId }: ViewDetailsButtonProps) => {
  const navigate = useNavigate()
  const { track } = useWebTracking()

  return (
    <BasicButton
      aria-label={`view details ${salesforceCreditId}`}
      size={BASIC_BUTTON_SIZE_SMALL}
      type={BASIC_BUTTON_TYPE_FLAT}
      onClick={() => {
        track('se_signup__application_dashboard_home_view_details__fired')
        navigate(salesforceCreditId)
      }}
    >
      <FormattedMessage
        defaultMessage='View details'
        id='sputnik.ViewDetailsButton__MnpUD7'
      />
    </BasicButton>
  )
}

export default ViewDetailsButton
